import React from 'react';
import classnames from 'classnames';
import { CreditCard } from '../../types';
import Amex from './assets/amex.inline.svg';
import ApplePay from './assets/applepay.inline.svg';
import GooglePay from './assets/googlepay.inline.svg';
import MasterCard from './assets/mastercard.inline.svg';
import Visa from './assets/visa.inline.svg';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

function getIcon(type) {
  switch (type) {
    case 'amex':
      return Amex;

    case 'applepay':
      return ApplePay;

    case 'mastercard':
      return MasterCard;

    case 'visa':
      return Visa;

    case 'googlepay':
      return GooglePay;

    default:
      return null;
  }
}

export const ICON_LIST = {
  visa: {
    icon: 'visa',
    alt: 'Visa'
  },
  mastercard: {
    icon: 'mastercard',
    alt: 'Mastercard'
  },
  amex: {
    icon: 'amex',
    alt: 'American Express'
  },
  applepay: {
    icon: 'applepay',
    alt: 'Apple Pay'
  },
  googlepay: {
    icon: 'googlepay',
    alt: 'Google Pay'
  }
};
export function isValidCardType(cardType) {
  return Object.keys(CreditCard).includes(cardType);
}
export const CardIcon = _ref => {
  var _ICON_LIST$cardType;

  let {
    cardType,
    className
  } = _ref;
  const Icon = getIcon((_ICON_LIST$cardType = ICON_LIST[cardType]) === null || _ICON_LIST$cardType === void 0 ? void 0 : _ICON_LIST$cardType.icon);

  if (!Icon) {
    return null;
  }

  return /*#__PURE__*/_jsx(Icon, {
    role: "img",
    "aria-label": "".concat(ICON_LIST[cardType].alt, " logo"),
    className: classnames(style.icon, className, {
      [style.withBorder]: cardType === 'mastercard',
      [style.applepay]: cardType === 'applepay'
    }),
    "data-id": "credit-card-icons_index_CardIcon_Icon"
  });
};
export const CardIcons = _ref2 => {
  let {
    className
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    "data-id": "credit-card-icons_index_CardIcon_div",
    children: /*#__PURE__*/_jsx("div", {
      className: style.icons,
      "data-id": "credit-card-icons_index_CardIcon_div_div_2",
      children: Object.keys(ICON_LIST).map(creditCard => /*#__PURE__*/_jsx(CardIcon, {
        cardType: creditCard,
        "data-id": "credit-card-icons_index_CardIcon"
      }, creditCard))
    })
  });
};
export default CardIcons;